//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ExamsActions from './actions';
import * as StandardExamsActions from '../standardexams/actions';
import * as ApExamsActions from '../apexams/actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
import * as OrganizationActions from '../organizations/actions';
import * as Sentry from "@sentry/react";
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------
export const handleListAllExamData = () => async (dispatch) => {
    try {
        const response  = await apis.get('exams', `/list_exam_data`);
        if(response&&response.success){
            const { standard_exams , ap_exams , exam_data  } = response.data || {};
            if(Array.isArray(standard_exams)){
                await dispatch(StandardExamsActions.listStandardExamssSuccess(standard_exams));
            }
            if(Array.isArray(ap_exams)){
                await dispatch(ApExamsActions.listApExamssSuccess(ap_exams));
            }
            if(Array.isArray(exam_data)){
                await dispatch(ExamsActions.listExamssSuccess(exam_data));
            }
        }
        return null;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing all exam data',
                error,
                module: 'EXAMS',
                operation: 'LIST_ACTIVITY_EXAM_DATA'
            });
        }
        return null;
    }
}

export const handleListExams = () => async (dispatch) => {
    await dispatch(ExamsActions.listExamss());

    try {
        const exams = await apis.get('exams', `/list`);
        if (Array.isArray(exams)) {
            await dispatch(ExamsActions.listExamssSuccess(exams));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing exams',
                error,
                module: 'EXAMS',
                operation: 'LIST_EXAM'
            });
        }
        await dispatch(ExamsActions.listExamssFail(error));
    }
};

export const handleCreateExams = (data) => async (dispatch) => {
    await dispatch(ExamsActions.createExams());
    try {
        const exam = await apis.post('exams', `/create`, {
            body: data
        });
        if (has(exam, "id")) {
            await dispatch(ExamsActions.createExamsSuccess(exam));
        }
        return exam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating exams',
                error,
                module: 'EXAMS',
                operation: 'CREATE_EXAM'
            });
        }
        await dispatch(ExamsActions.createExamsFail(error));
    }
};
export const handleUpdateExams = (data) => async (dispatch) => {
    await dispatch(ExamsActions.updateExams());
    try {
        const exam = await apis.put('exams', `/update`, {
            body: data
        });
        if (has(exam, "id")) {
            await dispatch(ExamsActions.updateExamsSuccess(exam));
        }
        return exam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating exams',
                error,
                module: 'EXAMS',
                operation: 'UPDATE_EXAM'
            });
        }
        await dispatch(ExamsActions.updateExamsFail(error));
    }
};
export const handleDeleteExam = (id) => async (dispatch) => {
    await dispatch(ExamsActions.deleteExams());
    try {
        const exam = await apis.del('exams', `/delete/${id}`);
        if (has(exam, "id")) {
            await dispatch(ExamsActions.deleteExamsSuccess(id));
        }
        return exam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting exams',
                error,
                module: 'EXAMS',
                operation: 'DELETE_EXAM'
            });
        }
        await dispatch(ExamsActions.deleteExamsFail(error));
    }
};
export const handleListExamDataByConfig = (data) => async (dispatch) => {
    try {
        const result = await apis.post('exams', `/list_exam_grades`, {
            body: data
        });

        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing exam data by config',
                error,
                module: 'EXAMS',
                operation: 'LIST_EXAM_DATA_BOOK_CLASS'
            });
        }
        return null;
    }
};

export const handleGetGradebookData = (data) => async (dispatch) => {
    try {
        const result = await apis.post('exams', `/get_gradebook_data`, {
            body: data
        });
        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting gradebook data',
                error,
                module: 'EXAMS',
                operation: 'GET_GROUP_DATA'
            });
        }
        return null;
    }
};
export const handleCreateDownloadList = (data) => async (dispatch) => {
    try {
        const result = await apis.post('exams', `/create_download_gradebook`, {
            body: data
        });
        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating download list',
                error,
                module: 'EXAMS',
                operation: 'CREATE_DIFFERENTIATION_LESSON'
            });
        }
        return null;
    }
};
export const handlelistDownloads = (data) => async (dispatch) => {
    try {
        const result = await apis.post('exams', `/list_download_by_class`, {
            body: data
        });
        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing downloads',
                error,
                module: 'EXAMS',
                operation: 'LIST_DEBATE'
            });
        }
        return null;
    }
};

export const handleFeedBackReport = (data) => async (dispatch) => {
    try {
        const response = await apis.post('exams', `/feedback_report`, {
            body: data
        });
        if(response){
            return response
        }else{
            return {success: false, result: []}
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`876 Error deleting standard exam: ${error}`);
        }
    }
};

export const handleGetStudentFeedBackReport = (data) => async (dispatch) => {
    try {
        const response = await apis.post('exams', `/get_student_feedback`, {
            body: data
        });
        if(response){
            return response
        }else{
            return {success: false, result: []}
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`876 Error deleting standard exam: ${error}`);
        }
    }
};


export const handleGetAssignmentStatus = (data) => async (dispatch) => {
    try {
        const response = await apis.post('exams', `/get_assignment_details`, {
            body: data
        });
        if(response){
            return response
        }else{
            return {success: false, result: []}
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`876 Error deleting standard exam: ${error}`);
        }
    }
};


export const handleGetOverallProgress = (data) => async (dispatch) => {
    try {
        const response = await apis.post('organizationsRDS', `/get_exams_by_book`, {
            body: data
        });
        if(response){
            return response
        }else{
            return {success: false, result: []}
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`876 Error deleting standard exam: ${error}`);
        }
    }
};


export const handleGetAssignmentStanard = (data) => async (dispatch) => {
    try {
        const response = await apis.post('assignmentsRDS', `/student_assignment_by_section`, {
            body: data
        });
        if(response){
            return response
        }else{
            return {success: false, result: []}
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`876 Error deleting standard exam: ${error}`);
        }
    }
};
